import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import FollowupHeader from './followupHeader';
import FollowupDetails from './followupDetails';
import useFollowupInvestigation from './useFollowupInvestigation';

// Followup item component - styled to match CheckItem
const FollowupCard = _ref => {
  let followupId = _ref.followupId,
    followup = _ref.followup,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? null : _ref$content,
    path = _ref.path,
    formActions = _ref.formActions,
    reduxEntity = _ref.reduxEntity,
    _ref$pendingOperation = _ref.pendingOperation,
    pendingOperation = _ref$pendingOperation === void 0 ? false : _ref$pendingOperation,
    notificationActions = _ref.notificationActions;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isRunning = _useState4[0],
    setIsRunning = _useState4[1];
  const hasAnalysis = !!followup.analysis;
  // Always expandable - either for reasoning, analysis results, or Run Analysis button
  const hasDetails = true;

  // Use custom hook for investigation logic
  const runInvestigation = useFollowupInvestigation({
    followupId,
    followup,
    content,
    path,
    formActions,
    reduxEntity,
    notificationActions,
    pendingOperation,
    setIsRunning
  });
  const handleToggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "border-bottom py-3"
  }, /*#__PURE__*/React.createElement(FollowupHeader, {
    followup: followup,
    isOpen: isOpen,
    onToggle: handleToggle,
    hasDetails: hasDetails
  }), hasDetails && /*#__PURE__*/React.createElement(FollowupDetails, {
    followup: followup,
    followupId: followupId,
    hasAnalysis: hasAnalysis,
    isOpen: isOpen,
    isRunning: isRunning,
    pendingOperation: pendingOperation,
    onRunInvestigation: runInvestigation
  }));
};
FollowupCard.propTypes = {
  followupId: PropTypes.string.isRequired,
  followup: PropTypes.shape({
    query: PropTypes.string,
    description: PropTypes.string,
    priority: PropTypes.number,
    reasoning: PropTypes.string,
    analysis: PropTypes.shape({
      summary: PropTypes.string,
      execution: PropTypes.shape({
        rows: PropTypes.arrayOf(PropTypes.shape({})),
        success: PropTypes.bool,
        rowCount: PropTypes.number
      }),
      recommendations: PropTypes.string
    })
  }).isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    formType: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  path: PropTypes.string.isRequired,
  formActions: PropTypes.shape({
    change: PropTypes.func.isRequired
  }).isRequired,
  reduxEntity: PropTypes.string.isRequired,
  pendingOperation: PropTypes.bool,
  notificationActions: PropTypes.shape({
    info: PropTypes.func.isRequired
  }).isRequired
};

// Removed defaultProps - using default parameters in function signature instead

export default FollowupCard;